













import { Component, Vue } from 'vue-property-decorator';
@Component({
  props: {},
})
export default class Dropdown extends Vue {}
